import { useEffect, useState } from 'react';

/**
 * https://react.dev/reference/react/useEffect#displaying-different-content-on-the-server-and-the-client
 */
export const useIsClient = () => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    if (!isClient) {
      setIsClient(true);
    }
  }, [isClient]);

  return isClient;
};
